// Static fallback / abstract bg url (not edited via admin)
export const ABSTRACT_BG =
  "https://static.prod-images.emergentagent.com/jobs/6e2f7376-7649-4dc8-b2ff-eefe1b692bf9/images/cdc4a9e015914a7c3d4e6a487d2cbfa8828d534b708cf21f9cdc5889847aa54d.png";

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "team", label: "Team" },
  { id: "achievements", label: "Achievements" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];
